/**
 * Class name joining, with Tailwind conflict resolution.
 *
 * `clsx` flattens conditionals; `tailwind-merge` then resolves the conflict, so
 * a caller's `className` can OVERRIDE a component's default. Without the merge
 * step, `<Button className="px-8">` and the button's own `px-3` both land in the
 * class list, and which one wins is decided by stylesheet order rather than by
 * intent — so an override silently does nothing on one screen and works on
 * another.
 *
 * Both dependencies were already in package.json and used nowhere. This is the
 * third time in this repository that a capability was installed, advertised in
 * a doc, and never wired.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
